/* global axios */

import ApiClient from './ApiClient';

class Agents extends ApiClient {
  constructor() {
    super('agents', { accountScoped: true });
  }

  bulkInvite({ emails }) {
    return axios.post(`${this.url}/bulk_create`, {
      emails,
    });
  }

  batchUpdate({ ids, availability }) {
    return axios.post(`${this.url}/batch_update`, {
      ids,
      availability,
    });
  }
}

export default new Agents();
